export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-5907HD_white-0b1469973d4bd8a94ef395a921861837.webp";